import { render, staticRenderFns } from "./wallet-card.vue?vue&type=template&id=9579b2f8&scoped=true&"
import script from "./wallet-card.vue?vue&type=script&lang=js&"
export * from "./wallet-card.vue?vue&type=script&lang=js&"
import style0 from "./wallet-card.vue?vue&type=style&index=0&id=9579b2f8&lang=scss&scoped=true&"
import style1 from "./wallet-card.vue?vue&type=style&index=1&id=9579b2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9579b2f8",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QCardActions,QBtn})
